import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Result, Card, Avatar } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import LoadingPage from './../../components/LoadingPage';
import { db, storage } from '../../config/Fire';
import * as Constants from './../../constants/nodes_database';
import imageReservando from './../../images/ic_launcher.png';
import android_icon from './../../images/android.png';
import apple_icon from './../../images/ios.png';
import home_icon from './../../images/image_home.png';
import phone_icon from './../../images/image_phone.png';
import facebook_icon from './../../images/image_facebook.png';
import instagram_icon from './../../images/image_instagram.png';
import './styles.css';

class Restaurants extends Component {
    state = {
        restaurant: null,
        restaurantError: false,
        fileListProfile: [],
    }

    componentDidMount() {
        const { location } = this.props;
        var paths = location.pathname.split("/");
        if(paths[2]) {
            db.ref(`${Constants.RESTAURANTS}/${paths[2]}`).once("value")
            .then((restoSnap) => {
                if(restoSnap.exists()) {
                    const restaurant = restoSnap.val();
                    if(restaurant && restaurant.logo && restaurant.logo !== "") {
                        var imagesProfile = [];
                        storage.ref().child(restaurant.logo).getDownloadURL()
                        .then(url => {
                            imagesProfile.push({ uid: - 1, name: "0", status: 'done', url: url });
                            this.setState({ restaurant, fileListProfile: imagesProfile });
                        })
                        .catch(err => {
                            console.log("Storage error: " + err);
                            this.setState({ restaurant });
                        });
                    } else {
                        this.setState({ restaurant });
                    }
                } else {
                    console.log("Error getting documents");
                    this.setState({ restaurantError: true });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ restaurantError: true });
            });
        }
    }

    render() {
        const { restaurant, fileListProfile } = this.state;
        return (
            <div>
                {
                    this.state.restaurantError ?
                        <Result
                            status="404"
                            title="404"
                            subTitle="Lo siento, el restaurante no existe."
                        />
                        :
                        restaurant ?
                            <div className="restaurantCont">
                                <Grid className="gridCont">
                                    <Row center="md">
                                        <Col xs={12} sm={12} md={8}>
                                            <Card
                                                style={{borderRadius: '6px', }}
                                                headStyle={{backgroundColor: 'rgb(242, 242, 242)', border: 0, borderRadius: '6px 6px 0 0', }}
                                                bodyStyle={{borderRadius: '0 0 6px 6px',}} 
                                                title={
                                                    <div className="titleCardCont">
                                                        <Avatar size={80} src={fileListProfile.length > 0 ? fileListProfile[0].url : imageReservando} /><br />
                                                        <h2>{restaurant.name}</h2>
                                                    </div>
                                                }>
                                                    <Grid>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <a href={`http://maps.google.com/maps?q=${restaurant.l[0]},${restaurant.l[1]}`} target="_blank" rel="noopener noreferrer"><Avatar size="large" src={home_icon}></Avatar></a>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <h3 className="tagTitleCont">{restaurant.address.street}</h3>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <h3>{restaurant.address.city}, CP {restaurant.address.postalCodeV2}</h3>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <a href={`http://maps.google.com/maps?q=${restaurant.l[0]},${restaurant.l[1]}`} target="_blank" rel="noopener noreferrer"><h4 className="purpleText">Ver en el mapa</h4></a>
                                                            </Col>
                                                        </Row>
                                                        <br />
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <a href={`tel:${restaurant.phone}`} target="_blank" rel="noopener noreferrer"><Avatar size="large" src={phone_icon}></Avatar></a>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <h3 className="tagTitleCont">{restaurant.phone}</h3>
                                                            </Col>
                                                        </Row>
                                                        <Row center="xs">
                                                            <Col xs={8}>
                                                                <a href={`tel:${restaurant.phone}`} target="_blank" rel="noopener noreferrer"><h4 className="purpleText">Llamar</h4></a>
                                                            </Col>
                                                        </Row>
                                                        <br />
                                                        <Row>
                                                            <Col xs={4}></Col>
                                                            <Col xs={2}>
                                                                <Row end="xs">
                                                                    <Col xs={12}>
                                                                        <a href={restaurant.facebook} target="_blank" rel="noopener noreferrer"><Avatar size="large" src={facebook_icon}></Avatar></a>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xs={2}>
                                                                <Row start="xs">
                                                                    <Col xs={12}>
                                                                        <a href={restaurant.instagram} target="_blank" rel="noopener noreferrer"><Avatar size="large" src={instagram_icon}></Avatar></a>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xs={4}></Col>
                                                        </Row>
                                                        <br />
                                                        <br />
                                                        <br />
                                                        <Row>
                                                            <Col xs={5}>
                                                                <Row end="xs">
                                                                    <Col xs={12}>
                                                                        <a href="https://play.google.com/store/apps/details?id=com.reservando.android" target="_blank" rel="noopener noreferrer"><Avatar size="large" src={android_icon}></Avatar></a>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xs={2}></Col>
                                                            <Col xs={5}>
                                                                <Row start="xs">
                                                                    <Col xs={12}>
                                                                        <a href="https://apps.apple.com/us/app/reservando/id1454333767?l=es&ls=1" target="_blank" rel="noopener noreferrer"><Avatar size="large" src={apple_icon}></Avatar></a>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Grid>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                            :
                            <LoadingPage />
                }
            </div>
        );
    }
}

export default withRouter(Restaurants);